export enum EMerchantAction {
	Edit = 'edit',
	Delete = 'delete',
}

export enum EUserManagementMerchantsPageGetParams {
	Action = 'action',
}

export enum EUserManagementMerchantsPageGetParamsActionTypes {
	Create = 'create',
}

export enum EMerchantsTableColumnKey {
	GUID = 'customer_guid',
	Name = 'name',
	CompanyCode = 'company_code',
	CallbackUrl = 'callback_url',
	Email = 'email',
	Menu = 'menu',
}

export enum EModalType {
	Create = 'create',
	Edit = 'edit',
}

export enum EMerchantCreateEditForm {
  CustomerGUID = 'customer_guid',
	Name = 'name',
	CompanyCode = 'company_code',
	CallbackUrl = 'callback_url',
	Email = 'email',
}
